import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

/**
 * Function which returns the value of the option from userConfiguration object
 */
export default function getPreferAccessibleContentOption(): boolean {
    const userOptions = getUserConfiguration().UserOptions;
    return !!(userOptions && userOptions.PreferAccessibleContent);
}
